module.exports = __webpack_public_path__ + "media/images/scarlet-logo-e27fcaf1d8d8df6d33c14864f1ca610b.png";